'use strict';

import React from 'react';
import PubSub from 'pubsub-js';
import { 
	FacebookButton, 
	FacebookCount,
	TwitterButton,
	TwitterCount } from "react-social";
//const FontAwesome = require('react-fontawesome');
import FontAwesome from 'react-fontawesome';

class Shares extends React.Component {
	constructor(props){
	  	super(props)
	  	this.state = {
	    	className: 'hidden'
	  	}
	}

	componentDidMount(){
	  	PubSub.subscribe('STATUS', (e,d) => {
	    	console.log(d)
	    	if(d.type == "TELEPORT_DONE"){
	    		this.setState({
	    		  	className: ""
	    		})
	    	}
	  	})
	}

	render() {
		let url = "https://t-e-l-e-p-o-r-t.me";

		return (
			<div className={"partages "+this.state.className}>
			    <ul>
			        <li className="p-mail">
			            <a href="mailto:atmet.ghazi@gmail.com">
			            	<FontAwesome name='envelope' />
			            </a>
			        </li>
			        <li className="p-tw">
        	            <TwitterButton url={url} message='TELEPORT ME ANYWHERE, NOW ! #streetview #teleport #webdev @Bounews'>
                            <FontAwesome name='twitter' />
                        </TwitterButton>
			        </li>
			        <li className="p-fb">
			            <FacebookButton url={url} appId={213703782565711}>
		                    <FontAwesome name='facebook' />
	                    	<div className="count">
	                    		(<FacebookCount url={url} />)
	                    	</div>
		                </FacebookButton>
			        </li>    
			    </ul> 
			</div>
		);
	}
}

Shares.displayName = 'Shares';

// Uncomment properties you need
// SharesComponent.propTypes = {};
// SharesComponent.defaultProps = {};

export default Shares;



// WEBPACK FOOTER //
// ./src/components/Shares.js